import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import { useToasts } from 'react-toast-notifications'

import { getMyEvents } from '_redux/modules/event'
import { getUserInfo } from '_utils/localData'

import AddPackingListModal from '../components/AddPackingListModal'
import EventCard from './components/EventCard'
import EventToolbar from './components/EventToolbar'
import useToolBar from './hooks/useToolBar'
import './style.scss'
import useBodyClass from '../../../hooks/useBodyClass'

const HostedEvent = () => {
  useBodyClass('hosted-event-change-bg')
  const dispatch = useDispatch()
  const history = useHistory()
  const { addToast } = useToasts()

  const userInfo = getUserInfo()
  const { myEvents } = useSelector((state) => state.event)

  const [isLoading, setIsLoading] = useState(false)
  const [isPackingListOpen, setIsPackingListOpen] = useState(false)

  const { visibleEvents, view, toolbarProps, isEventClosed, filter } = useToolBar(myEvents)

  useEffect(() => {
    const fetchEvents = async () => {
      setIsLoading(true)
      try {
        await dispatch(getMyEvents)
      } catch (error) {
        addToast(error?.message, { appearance: 'error', autoDismiss: true })
      }
      setIsLoading(false)
    }
    fetchEvents()
  }, [])

  const togglePackingListModal = () => {
    if (!userInfo?.isUsingFeature) {
      addToast('This feature is currently available to a limited set of users for testing', {
        appearance: 'info',
        autoDismiss: true,
      })
      return
    }
    setIsPackingListOpen((prev) => !prev)
  }

  return (
    <div className="hosted-event-page">
      <div className="hosted-event-page__header">
        <div>
          <h1>Hosted Events</h1>
          <p>Manage your group buy events and packages</p>
        </div>
        <div className="hosted-event-page__header-actions">
          {userInfo?.isUsingFeature && (
            <>
              <button
                type="button"
                className="hosted-event-btn hosted-event-btn--outline"
                onClick={() => history.push('/event/list-packing-list')}
              >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line></svg>
                Packing Lists
              </button>
              <button
                type="button"
                className="hosted-event-btn hosted-event-btn--outline"
                onClick={togglePackingListModal}
              >
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 11l3 3L22 4"></path><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path></svg>
                New Packing List
              </button>
            </>
          )}
          <button
            type="button"
            className="hosted-event-btn hosted-event-btn--primary"
            onClick={() => history.push('/event/hosting')}
          >
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M6 1v10M1 6h10"></path></svg>
            New event
          </button>
        </div>
      </div>

      <EventToolbar {...toolbarProps} />

      {isLoading ? (
        <div className="hosted-event-page__loading">Loading...</div>
      ) : (
        <>
          <div className={`hosted-event-page__list hosted-event-page__list--${view}`}>
            {visibleEvents.map((event) => (
              <EventCard
                key={event.id}
                event={event}
                variant={view}
                isClosed={isEventClosed(event)}
              />
            ))}
          </div>

          {visibleEvents.length === 0 && (
            <div className="hosted-event-page__empty">
              {filter === 'all'
                ? 'You currently have no events yet.'
                : 'No events match this filter.'}
            </div>
          )}
        </>
      )}

      {isPackingListOpen && (
        <AddPackingListModal
          modal={isPackingListOpen}
          toggle={togglePackingListModal}
          listEvent={myEvents}
        />
      )}
    </div>
  )
}

export default HostedEvent
